/*
 * Module for the Retirement Deposit Option step of the Employment Separation Options form
*/
rs.module("ui/content/communications/onlineforms/retirementdepositoption",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var retirementDepositOptionRadio = stepContainer.js(jsSelectors.retirementDepositOptionRadio, { multiple: true });
            var retirementDepositOptionDescriptionDiv = stepContainer.js(jsSelectors.retirementDepositOptionDescriptionDiv, { multiple: true });
            var refundContributionsOptionRadio = stepContainer.js(jsSelectors.refundContributionsOptionRadio, { multiple: true, required: false });
            var refundContributionsOptionDescriptionDiv = stepContainer.js(jsSelectors.refundContributionsOptionDescriptionDiv, { multiple: true, required: false });
            var retainRetirementSystemOptionRadio = stepContainer.js(jsSelectors.retainRetirementSystemOptionRadio, { multiple: true, required: false });
            var retainRetirementSystemOptionDescriptionDiv = stepContainer.js(jsSelectors.retainRetirementSystemOptionDescriptionDiv, { multiple: true, required: false });
            var partialPaymentAmount = stepContainer.js(jsSelectors.partialPaymentAmount);

            var withdrawalModal = $.js(jsSelectors.withdrawalModal);
            var modalSubmitButton = $.js(jsSelectors.modalSubmitButton);
            var withdrawalConfirmationFlag = $.js(jsSelectors.withdrawalConfirmationFlag);

            // Initialize selection of retirement deposit option radio if applicable
            var selectedRetirementDepositOption = retirementDepositOptionRadio.filter(":checked");
            var selectedRetirementDepositOptionIndex = retirementDepositOptionRadio.index(selectedRetirementDepositOption);
            if (selectedRetirementDepositOptionIndex !== null && selectedRetirementDepositOptionIndex >= 0) {
                showSelectedRetirementDepositOptionDescription(selectedRetirementDepositOptionIndex, false);
            }

            // Initialize selection of refund contributions option radio if applicable
            var selectedRefundContributionsOption = refundContributionsOptionRadio.filter(":checked");
            var selectedRefundContributionsOptionIndex = refundContributionsOptionRadio.index(selectedRefundContributionsOption);
            if (selectedRefundContributionsOptionIndex !== null && selectedRefundContributionsOptionIndex >= 0) {
                showSelectedRefundContributionsOptionDescription(selectedRefundContributionsOptionIndex);
            }

            // Initialize selection of retain retirement system option radio if applicable
            var selectedRetainRetirementSystemOption = retainRetirementSystemOptionRadio.filter(":checked");
            var selectedRetainRetirementSystemOptionIndex = retainRetirementSystemOptionRadio.index(selectedRetainRetirementSystemOption);
            if (selectedRetainRetirementSystemOptionIndex !== null && selectedRetainRetirementSystemOptionIndex >= 0) {
                showSelectedRetainRetirementSystemOptionDescription(selectedRetainRetirementSystemOptionIndex);
            }

            // Handle the retirementDepositOptionRadio click event
            retirementDepositOptionRadio.on("click", function () {
                clearPartialPayment();

                var selectedRetirementDepositOptionIndex = retirementDepositOptionRadio.index(this);
                showSelectedRetirementDepositOptionDescription(selectedRetirementDepositOptionIndex, true);
            });

            // Handle the refundContributionsOptionRadio click event
            refundContributionsOptionRadio.on("click", function () {
                clearPartialPayment();

                var selectedRefundContributionsOptionIndex = refundContributionsOptionRadio.index(this);
                showSelectedRefundContributionsOptionDescription(selectedRefundContributionsOptionIndex);
            });

            // Handle the retainRetirementSystemOptionRadio click event
            retainRetirementSystemOptionRadio.on("click", function () {
                clearPartialPayment();

                var selectedRetainRetirementSystemOptionIndex = retainRetirementSystemOptionRadio.index(this);
                showSelectedRetainRetirementSystemOptionDescription(selectedRetainRetirementSystemOptionIndex);
            });

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            var skipModal = false;

            // Handle next button click event
            wizardNextButton.on("click", function (e) {

                if (!skipModal && shouldShowModal()) {
                    e.preventDefault(); // stop wizard navigation

                    withdrawalModal.modal("show");

                    return false;
                }

                skipModal = false;
            });

            // Handle modal submit button click event
            modalSubmitButton.on("click", function () {

                withdrawalConfirmationFlag.val("true");

                withdrawalModal.modal("hide");

                // Trigger wizard next button click but bypass modal this time
                skipModal = true;

                wizardNextButton.trigger("click");
            });

            // Show (slide down) the description for the selected retirement deposit option
            function showSelectedRetirementDepositOptionDescription(selectedIndex, clear) {
                // Close all quickly
                retirementDepositOptionDescriptionDiv.stop(true, true).slideUp(150);
                refundContributionsOptionDescriptionDiv.stop(true, true).slideUp(150);
                retainRetirementSystemOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Uncheck slide out radios conditionally
                if (clear) {
                    clearSlideOutRadioSelections();
                }

                // Open the selected one
                retirementDepositOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Show (slide down) the description for the selected refund contributions option
            function showSelectedRefundContributionsOptionDescription(selectedIndex) {
                // Close all quickly
                refundContributionsOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                refundContributionsOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Show (slide down) the description for the selected retain in retirement system option
            function showSelectedRetainRetirementSystemOptionDescription(selectedIndex) {
                // Close all quickly
                retainRetirementSystemOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                retainRetirementSystemOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Clear all selected radios that appear in slide out sections
            function clearSlideOutRadioSelections() {

                refundContributionsOptionRadio.prop("checked", false);
                refundContributionsOptionRadio.clearErrors();

                retainRetirementSystemOptionRadio.prop("checked", false);
                retainRetirementSystemOptionRadio.clearErrors();
            }

            function shouldShowModal() {
                var selectedOption = retirementDepositOptionRadio.filter(":checked").val();

                var refundOptionSelected =
                    refundContributionsOptionRadio.filter(":checked").length > 0;

                return (selectedOption === "RefundOfContributions") && refundOptionSelected && !showPartialPaymentError();
            }

            // Clear partial payment amount and errors
            function clearPartialPayment() {

                partialPaymentAmount.val('');
                partialPaymentAmount.clearErrors();
            }

            // Returns true if partial payment error should appear
            function showPartialPaymentError() {
                var selectedOption = retirementDepositOptionRadio.filter(":checked").val();

                var selectedRefund = refundContributionsOptionRadio.filter(":checked").val();

                return (selectedOption === "RefundOfContributions") &&
                    (selectedRefund === "PartialDistributionPartialRollover") &&
                    (partialPaymentAmount.val() == '');
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);